module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "loading__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "loading__content elevation-1"
  }, [_c('div', {
    staticClass: "loading__bar pa-5"
  }, [_c('v-progress-circular', {
    staticClass: "blue-grey--text text-xs-center",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "indeterminate": "",
      "width": 2,
      "size": 70
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25ca561d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrbLoading.vue
// module id = 555
// module chunks = 1